/**
 * Defines how the player handles Media Source Extensions (MSE) when crossing
 * manifest period boundaries.
 */
export enum CrossBoundaryStrategy {
  /**
   * Do not reset MSE when crossing a period boundary.
   */
  KEEP = 'KEEP',

  /**
   * Reset MSE only when crossing into encrypted content.
   */
  RESET_TO_ENCRYPTED = 'RESET_TO_ENCRYPTED',

  /**
   * Always reset MSE when crossing a period boundary.
   */
  RESET = 'RESET',
}
